export function round(num) {
  return Math.round(num * 100) / 100;
}

export function ratio() {
  const winWidth = window.innerWidth;
  return winWidth >= 750 ? 1 : round(winWidth / 750);
}
